import {Component, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import { AuthService, PageNotificationService, ShareDataService, PhoneOrderSharedService, UserService } from '@signature-it/ngx-generic/services';
import { FakeloaderComponent } from '@signature-it/ngx-generic/components/fakeloader';
import { SignedUserDTO, UserFactory } from '@signature-it/ngx-generic/models';
import {RestUrlsConfig} from '@signature-it/ngx-generic/config';

declare let sessionStorage: any;

@Component({
    selector: 'phone-order',
    templateUrl: './phone-order.html',
    styleUrls: ['./phone-order.scss'],
    standalone: false
})
export class PhoneOrderComponent implements OnInit {
    // menuList: Array<UserNavigation>;
    currentUser: any;
    relevantUser: SignedUserDTO;
    static userAuthenticated = false;

    constructor(protected router: Router,
                protected notifySvc: PageNotificationService,
                protected authSvc: AuthService,
                protected userSvc: UserService,
                protected phoneSharedSvc: PhoneOrderSharedService,
                protected sharedSvc: ShareDataService,
                public restUrlsConf: RestUrlsConfig) {
    }

    ngOnInit() {
        const self = this;
        // this.menuList = [];
        // // relevant user's details
        this.authSvc.usersData$.subscribe(function(user: SignedUserDTO){
            self.relevantUser = user;
        });

        // when login flag is changing
        this.sharedSvc.loginData$.subscribe(
            (isLoggedIn: boolean) => {
                PhoneOrderComponent.userAuthenticated = isLoggedIn;
            }
        );
        // // do phone order action
        // this.phoneSharedSvc.enablePhoneOrder$.subscribe(
        //     (identifier: string) => {
        //         if(!_.isEmpty(identifier)) {
        //             this._enablePhoneOrderMode(identifier);
        //         }
        //     }
        // );
        // when phone order is enabled
        this.phoneSharedSvc.onPhoneOrderEnabled$.subscribe(
            (value: boolean) => {
                if(value === true) {
                    this._enablePhoneOrderModeCallback()
                }
            }
        );
        // do phone order action
        this.phoneSharedSvc.disablePhoneOrder$.subscribe(
            (redirectUrl: string) => {
                if(this.isPhoneOrderMode && redirectUrl) {
                    this._logoutPhoneOrderMode(redirectUrl);
                    // clear previous value
                    this.phoneSharedSvc.disablePhoneOrder$.next("");
                }
            }
        );
        // when phone order is disabled
        this.phoneSharedSvc.onPhoneOrderDisabled$.subscribe(
            (value: boolean) => {
                if(this.isPhoneOrderMode && value === true) {
                    this._logoutPhoneOrderModeCallback();
                }
            }
        );
    }

    get isUserAuthenticated() {
        return PhoneOrderComponent.userAuthenticated;
    }

    get isPhoneOrderMode() {
        return this.phoneSharedSvc.phoneOrderMode;
    }

    phoneOrderLogout(redirectUrl?: string) {
        this._logoutPhoneOrderMode(redirectUrl);
    }

    protected _enablePhoneOrderMode(identifier: string, redirectUrl?: string) {
        // if(_.isEmpty(identifier)) {
        //     this.notifySvc.set("Invalid POSCustomerNumber was specified.", 500).show();
        //     return;
        // }
        //
        // FakeloaderComponent.start();

        // this.callCenterSvc
        //     .phoneOrderEnable({
        //         [SignedUserDTO.ATTR_POS_CUSTOMER_NUMBER]: identifier
        //     })
        //     .finally(() => {
        //         setTimeout(() => FakeloaderComponent.stop(), 3000);
        //     })
        //     .subscribe(
        //         (response: object) => {
        //             const storage = Storages.sessionStorage;
        //             storage.set(PhoneOrderSharedService.ATTR_PHOM, true);
        //             // handle user details, then redirect to the given url
        //             this.authSvc.handleAuthentication(redirectUrl);
        //
        //             // this.notifySvc.set("Phone order mode has been enabled.", 200).show();
        //
        //             if(response['success'] === true) {
        //                 this.phoneSharedSvc.onPhoneOrderEnabledSuccess$.next(response);
        //             }
        //         },
        //         error => {
        //             this._logoutPhoneOrderModeCallback();
        //             this.notifySvc.set(error).show();
        //         })
        // ;
    }

    protected _logoutPhoneOrderMode(redirectUrl?: string) {
        FakeloaderComponent.start();

        this.authSvc
            .phoneOrderLogout()
            .subscribe(
                (disabled: boolean) => {
                    // set phone order customer
                    this.phoneSharedSvc.setPhoneOrderState(false);
                    // handle user details, then redirect to the given url
                    this.authSvc.handleAuthentication(redirectUrl);
                    setTimeout(() => FakeloaderComponent.stop(), 3000);
                    // this.notifySvc.set("Phone order mode has been disabled.", 200).show();
                },
                error => {
                    this.phoneSharedSvc.setPhoneOrderState(false);
                    this.notifySvc.set(error).show();
                    setTimeout(() => FakeloaderComponent.stop(), 3000);
                });
    }

    protected _enablePhoneOrderModeCallback() {
        if(Boolean(sessionStorage.getItem(PhoneOrderSharedService.ATTR_PHOM))) {
            const attributes = JSON.parse(sessionStorage.getItem(PhoneOrderSharedService.ATTR_CCUD));
            const tmpUser = UserFactory.create(attributes);
            if(!(tmpUser instanceof SignedUserDTO) && !(this.currentUser instanceof SignedUserDTO)) {
                this.userSvc
                    .getCurrentUserDetails()
                    .subscribe(
                        (user: SignedUserDTO) => {
                            this.currentUser = user;
                            sessionStorage.setItem(PhoneOrderSharedService.ATTR_CCUD, JSON.stringify(user));
                            this.phoneSharedSvc.phoneOrderMode = true;
                            this.authSvc.currentUsersData$.next(this.currentUser);
                            this.onPhoneOrderModeEnabled();
                        },
                        error => {
                            this.currentUser = null;
                            sessionStorage.removeItem(PhoneOrderSharedService.ATTR_CCUD);
                            this.phoneSharedSvc.phoneOrderMode = false;
                            this.notifySvc.set(error).show();
                        }
                    );
            } else {
                this.currentUser = <SignedUserDTO>tmpUser;
                this.currentUser.phone_order_mode = true;
                this.phoneSharedSvc.phoneOrderMode = true;
                this.authSvc.currentUsersData$.next(this.currentUser);
                this.onPhoneOrderModeEnabled();
            }
        }
    }

    protected onPhoneOrderModeEnabled() {}

    protected _logoutPhoneOrderModeCallback() {
        if(Boolean(sessionStorage.getItem(PhoneOrderSharedService.ATTR_PHOM))) {
            sessionStorage.removeItem(PhoneOrderSharedService.ATTR_CCUD);
            sessionStorage.removeItem(PhoneOrderSharedService.ATTR_PHOM);
            // set phone order state
            if(this.currentUser instanceof SignedUserDTO) {
                this.currentUser.phone_order_mode = false;
            }
        }
        this.phoneSharedSvc.phoneOrderMode = false;
        this.phoneSharedSvc.onPhoneOrderDisabledSuccess$.next({});
    }

}
